module.exports = __webpack_public_path__ + "media/images/categories/headers/employment-c32479a89d8bf4fbc0bccb83460b30fb.jpg";